import { mpfRListsHttp } from '../../api/mpf-r-lists-http'
import { isArchivedFilter } from '../data'

interface DueOutHistory {
  'Action/Action'?: string
  ActionCode: string
  AssignedTo?: string
  DueOutGUID: string
  DueOutID: string
  IsArchived?: boolean
  ItemCreated: Date
  ItemCreatedBy: string
  'ItemCreatedBy/edipi'?: string
  'ItemCreatedBy/email'?: string
  'ItemCreatedBy/firstname'?: string
  'ItemCreatedBy/lastname'?: string
  ItemModified: Date
  ItemModifiedBy: string
  'ItemModifiedBy/edipi'?: string
  'ItemModifiedBy/email'?: string
  'ItemModifiedBy/firstname'?: string
  'ItemModifiedBy/latname'?: string
  'PreviousStatus/StatusDescription'?: string
  PreviousStatusCode: string
  'Section/MetadataValue'?: string
  SectionCode: number
  ServicingBy: string
  'Status/StatusDescription'?: string
  StatusCode: string
  UserRole: string
  WaitingOnUserRole: string
  eKey : string
  eTag : string
}

interface DueOutHistoryArgs {
  DueOutGUID: string
  isArchivedFilter: false | null | true
  isAscending?: boolean
  orderBy?: string
}

const COLUMN_NAMES = {
  Action: 'Action/Action',ActionCode: 'ActionCode',
  AssignedTo: 'AssignedTo',
  DueOutGUID: 'DueOutGUID',
  DueOutID: 'DueOutID',
  IsArchived: 'IsArchived',
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemCreatedByEDIPI: 'ItemCreatedBy/edipi',
  ItemCreatedByEmail: 'ItemCreatedBy/email',
  ItemCreatedByFirstName: 'ItemCreatedBy/firstname',
  ItemCreatedByLastName: 'ItemCreatedBy/lastname',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
  ItemModifiedByEDIPI: 'ItemModifiedBy/edipi',
  ItemModifiedByEmail: 'ItemModifiedBy/email',
  ItemModifiedByFirstName: 'ItemModifiedBy/firstname',
  ItemModifiedByLastName: 'ItemModifiedBy/lastname',
  PreviousStatusCode: 'PreviousStatusCode',
  Section: 'Section/MetadataValue',
  SectionCode: 'SectionCode',
  ServicingBy: 'ServicingBy',
  Status: 'Status/StatusDescription',
  StatusCode: 'StatusCode',
  UserRole: 'UserRole',
  WaitingOnUserRole: 'WaitingOnUserRole',
  eKey:"eKey",
  eTag:'eTag',
}
const LIST_NAME = 'DueOutHistoryList'

const getDueOutHistory = async (
  args: DueOutHistoryArgs
): Promise<DueOutHistory[]> => {
  const list = await mpfRListsHttp().getList(LIST_NAME)
  const filter = isArchivedFilter(args.isArchivedFilter)
  const ascending = args?.isAscending ?? true
  const orderBy = args?.orderBy ?? 'ORDER_BY_HERE'

  const items = await list
    .query()
    .filter(filter)
    .select(...Object.values(COLUMN_NAMES))
    .expand()
    .orderBy([{ ascending: ascending, orderBy: orderBy }])
    .get()

  return [...items] as DueOutHistory[]
}
const getDueOutHistoryItems = async (
  args: DueOutHistoryArgs
): Promise<DueOutHistory[]> => {
  const list = await mpfRListsHttp().getList(LIST_NAME)
  const filter = `DueOutGUID eq '${args?.DueOutGUID}'`
  const items = await list
    .query()
    .filter(filter)
    .select(...Object.values(COLUMN_NAMES))
    .expand(
      'ItemCreatedBy',
      'ItemModifiedBy',
      COLUMN_NAMES.AssignedTo
    )
    .orderBy([{ ascending: false, orderBy: COLUMN_NAMES.ItemCreated }])
    .get()

  return [...items] as DueOutHistory[]
}
const addOrUpdateDueOutHistory = async (item : DueOutHistory) => {
  try {
    const list = await mpfRListsHttp().getList(LIST_NAME)
    
    const result = await list.addOrUpdateItem(item)
    
    return result
  } catch (error) {
    console.error('An error occurred while adding or updating the dueout in the history list:', error)
    throw new Error('Failed to add or update dueout in the history')
  }
}
export {
  COLUMN_NAMES,
  type DueOutHistory,
  type DueOutHistoryArgs,
  LIST_NAME,
  addOrUpdateDueOutHistory,
  getDueOutHistory,
  getDueOutHistoryItems
}
